import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const Slug = z.string().min(1);
// These legacy payloads are deliberately types-only for now. Their database
// shapes are shared with the learner app and are being tightened separately;
// the request contract is still authoritative for paths and parameters.
const LegacyObjectResponse = z.object({}).passthrough();
const ProsumerProjectResponse = z
    .object({
    slug: z.string(),
    name: z.string(),
    description: z.string(),
    image_url: z.string(),
    topic: z.string(),
    is_submitted: z.boolean(),
    is_finished: z.boolean(),
    is_joined: z.boolean().optional(),
    question_count: z.number(),
    completedQuestions: z.number().nullable(),
    tags: z.array(z.string()),
    // Keys are question slugs and values vary by question type.
    answer_states: z.record(z.unknown()).nullable(),
})
    // Preserve forward-compatible fields returned by the legacy dashboard API.
    .passthrough();
const LegacyObjectListResponse = z.array(ProsumerProjectResponse);
export const getProsumerActivityRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/missions/{missionSlug}/activities/{activitySlug}',
    name: 'get-activity-prosumer',
    request: { params: z.object({ missionSlug: Slug, activitySlug: Slug }) },
    responses: {
        200: LegacyObjectResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getProsumerProjectRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/projects/{projectSlug}',
    name: 'get-prosumer-project',
    request: { params: z.object({ projectSlug: Slug }) },
    responses: { 200: LegacyObjectResponse, 400: HttpErrorResponse },
};
export const getProsumerProjectsRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/projects/',
    name: 'get-prosumer-projects',
    request: {},
    responses: { 200: LegacyObjectListResponse, 400: HttpErrorResponse },
};
export const getProsumerStatsRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/{contentSlug}/stats',
    name: 'get-stats-prosumer',
    request: { params: z.object({ contentSlug: Slug }) },
    responses: { 200: LegacyObjectResponse, 400: HttpErrorResponse },
};
export const getProsumerProfileRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/profile',
    name: 'get-prosumer-profile',
    request: {},
    responses: { 200: LegacyObjectResponse, 400: HttpErrorResponse },
};
export const getProsumerUpsellRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/upsell',
    name: 'get-prosumer-upsell-data',
    request: {},
    responses: { 200: LegacyObjectResponse, 400: HttpErrorResponse },
};
export const checkProsumerEmailAvailabilityRoute = {
    version: 1,
    method: 'GET',
    path: '/prosumer/email-availability/{email}',
    name: 'check-email-availability',
    request: { params: z.object({ email: z.string().min(1) }) },
    responses: {
        200: z.object({ isAvailable: z.boolean() }),
        400: HttpErrorResponse,
    },
};
